import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getInjectiveAddress } from "@injectivelabs/sdk-ts";

export interface IWallet {
  address: string;
  walletConnectType: string;
}

const initialState: IWallet = {
  address: "",
  walletConnectType: "",
};
export const WalletSlice = createSlice({
  name: "wallet_slice",
  initialState,
  reducers: {
    setWallet: (state, action: PayloadAction<IWallet>) => {
      // state.address = getInjectiveAddress(action.payload.address);
      state.address = action.payload.address;
      state.walletConnectType = action.payload.walletConnectType;
    },
  },
});

export const { setWallet } = WalletSlice.actions;

export default WalletSlice.reducer;
